import styled from "styled-components";

const PageContainer = styled.div`
    .footer-fixed ~ & {
        padding-bottom: 48px;
    }
`;
export default PageContainer;



// WEBPACK FOOTER //
// ./src/components/PageContainer.js


// WEBPACK FOOTER //
// ./src/components/PageContainer.js